import { atom } from 'jotai';

export const productWallErrorMessageAtom = atom('');
export const productWallHasErrorAtom = atom(false);
